// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinNow_container__CZGG2","logo":"JoinNow_logo__bCwEI","button":"JoinNow_button__n6kDx"};